import { render, staticRenderFns } from "./NavigationFooter.vue?vue&type=template&id=01d98f40&functional=true&"
var script = {}
import style0 from "./NavigationFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports